import { all, takeLatest, call, put } from "redux-saga/effects";
import {
  fetchFeaturedList,
  fetchHomePageCarouselList,
  fetchHomePageFeatureBanner,
  fetchLatestNews,
  fetchAdvisoriesList,
  fetchQuickLins,
} from "network/services/homepage";
import {
  fetchHomePageDataFailed,
  fetchHomePageDataSuccess,
} from "../actionCreators";
import type { ISaga, HomePageData } from "../types";
import { ewbConfig } from "config";

function* fetchHomePageData(): ISaga {
  try {
    const [
      carouselData,
      featureBannerData,
      financialResponse,
      waysWeCanHelp,
      latest_news,
      advisories,
      quick_links,
    ] = yield all([
      call(fetchHomePageCarouselList),
      call(fetchHomePageFeatureBanner),
      call(fetchFeaturedList, 8),
      call(fetchFeaturedList, 9),
      call(fetchLatestNews),
      call(fetchAdvisoriesList),
      call(fetchQuickLins),
    ]);

    let quick_links_items = quick_links.data?.map(
      ({ title, field_image, field_link_url }) => ({
        label: title,
        icon: ewbConfig.apiUrl + field_image,
        link: field_link_url,
      })
    );

    const payload: HomePageData = {
      carouselData: carouselData.data,
      financialData: financialResponse.data,
      waysWeCanHelpData: waysWeCanHelp.data,
      productBanner: featureBannerData.data,
      quickLinks: quick_links_items,
      latest_news: latest_news.data.slice(0, 3),
      advisories: advisories.data.slice(0, 3),
    };

    yield put(fetchHomePageDataSuccess(payload));
  } catch (e) {
    yield put(fetchHomePageDataFailed());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_HOME_PAGE_DATA", fetchHomePageData);
}
